module.exports = __webpack_public_path__ + "zxbj.png?e9f9859cd894385e65545a5e90c9faaa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zxbj.png
// module id = 618
// module chunks = 0